export default "__VITE_ASSET__BUxSH0n2__"